import React, { useEffect, useState } from 'react';
import { Col, Row, Button, Modal, Form, Image, Container } from 'react-bootstrap';
import '../Assets/css/header.css';
import { useHistory, NavLink } from 'react-router-dom';
import { base_url } from '../Helpers/request';
import { user } from '../Helpers/request';
import 'react-toastify/dist/ReactToastify.css';
import { isMobileOnly, isTablet } from "react-device-detect";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { Breadcrumbs, CircularProgress, TextField, Typography } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import axios from 'axios';
import swal from 'sweetalert';
import login_img from '../Assets/images/icon/user.png';
import { BiUser } from "react-icons/bi";
import User1 from "../../src/Assets/images/user1.png";
import User2 from "../../src/Assets/images/user2.gif";
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
import { gapi } from 'gapi-script';
import { cartlengthvalue } from '../Reducer/cartReducer';
import { useDispatch } from 'react-redux';
import { whishlistlength } from '../Reducer/wishlistReducer';

const Login = (props) => {
    const [errmsg, setErrmsg] = useState(false);
    const [msg, setMsg] = useState('');
    //login
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');


    const dispatch = useDispatch()
    useEffect(() => {
        gapi.load('client:auth2', () => {
            gapi.client.init({
                clientId: "549981789532-4bt0u9a45fujhv35ha0dil32bomr9221.apps.googleusercontent.com",
                plugin_name: "chat"
            })
        })
    }, [])
   
    const handlesubmitlogin = (e) => {
        setErrmsg(false);
        e.preventDefault();
        setButtonLoading(true);
        axios.post(base_url + '/user/login', { email, password, session_id: localStorage.getItem("dfl-session-id") ? localStorage.getItem("dfl-session-id") : "" }, {
            headers: {
                // 'authorization':`Token e222085edc871220cae528152b73c1317ba2addf`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                if (response.data.status == 1) {
                    window.location.reload(true);
                    var user = {
                        token: response.data.data.token,
                        user_id: response.data.data.user_id,
                        email: response.data.data.email,
                        first_name: response.data.data.first_name,
                        last_name: response.data.data.last_name,
                        isLogin: true
                    }
                    dispatch(cartlengthvalue(response.data.data.total_cart_count))
                    dispatch(whishlistlength(response.data.data.total_wish_count))
                    localStorage.setItem("dfl-user", JSON.stringify(user));
                    localStorage.removeItem("dfl-session-id")
                    setEmail("");
                    setPassword("");
                    setButtonLoading(false);
                    window.location.href = "/";
                } else {
                    setButtonLoading(false);
                    setErrmsg(true)
                    setMsg(response.data.message)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const responseGoogle = (response) => {
        console.log(response);
        const data = {
            first_name: response.profileObj.givenName,
            last_name: response.profileObj.familyName,
            social_id: response.profileObj.googleId,
            login_method: 2,
            email: response.profileObj.email,
            session_id: localStorage.getItem("dfl-session-id") ? localStorage.getItem("dfl-session-id") : "",
            language: "EN",
            currency: "USD"
        }
        axios.post(`${base_url}/user/socialLogin`, data, {
            headers: {
                // 'authorization':`Token e222085edc871220cae528152b73c1317ba2addf`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (response.data.status == 1) {
                window.location.reload(true);
                var user = {
                    token: response.data.data.token,
                    user_id: response.data.data.user_id,
                    email: response.data.data.email,
                    first_name: response.data.data.first_name,
                    last_name: response.data.data.last_name,
                    isLogin: true
                }
                dispatch(cartlengthvalue(response.data.data.total_cart_count))
                dispatch(whishlistlength(response.data.data.total_wish_count))
                localStorage.setItem("dfl-user", JSON.stringify(user));
                localStorage.removeItem("dfl-session-id");
                setEmail("");
                setPassword("");
                setButtonLoading(false);
                window.location.href = '/';
            } else {
                setButtonLoading(false);
                setErrmsg(true)
                setMsg(response.data.message)
            }
        })
            .catch((error) => {
                console.log(error);
            });
    }
    const [buttonLoading, setButtonLoading] = useState(false)
    return (<>
        {/* {isLogin ?
            <>
                <Button className="rcs_blank_button rcs_after_login_button" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClicktop}>{isMobileOnly ? <span className="rcs_mobile">{user.first_name[0]}</span> : isTablet ? <span className="rcs_mobile">{user.first_name[0]}</span> : <span className="rcs_mobile">{user.first_name[0]} <KeyboardArrowDownIcon />  </span>}</Button>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    className="rcs_menu_list_item"
                    open={Boolean(anchorEl)}
                    onClick={handleClosetop}
                >
                    <MenuItem disabled><BiUser /> {user.first_name}</MenuItem>
                    <MenuItem onClick={() => history.push("/account/myaccount")}>My Account</MenuItem>
                    <MenuItem onClick={handlelogout}>Logout</MenuItem>
                </Menu>
            </> :
            isMobileOnly ? <Button variant="link" className="rcs_before_login" id="loginbutton" onClick={signin}> <BiUser /> <span className='dfl_right_menu_text' style={{ cursor: "pointer" }}>  Login </span> </Button> :
                <span id="loginbutton" onClick={signin}> <img className='rcs_wishlist_icon' src={User1} /> <span className='dfl_right_menu_text' style={{ cursor: "pointer" }}>  Login </span></span>
        } */}
        <Container className='mt-2'>
            <Row>
                <Col className="rcs_breadcrumb mb-2">
                    <Breadcrumbs aria-label="breadcrumb">
                        <NavLink underline="hover" color="inherit" to="/">
                            Home
                        </NavLink>
                        <Typography color="text.primary">Login</Typography>
                    </Breadcrumbs>
                </Col>
            </Row>
        </Container>


        <section className='dfl_login_section'>
            <Container>
                <Row>
                    <Col lg={7} className="m-auto">
                        <Modal.Body>

                            <div className="rcs_appointment_input rcs_login">
                                <Modal.Title id="contained-modal-title-vcenter">Login</Modal.Title>
                                <Form onSubmit={handlesubmitlogin}>
                                    <Row>
                                        <Col>
                                            <TextField
                                                id="outlined-basic"
                                                label="Email"
                                                type="email"
                                                variant="outlined"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <TextField
                                                id="outlined-basic"
                                                label="Password"
                                                type="password"
                                                variant="outlined"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <NavLink className="rcs_login_forgot rcs_forogt_pass" to="/forgot">Forgot Password ?</NavLink>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={10} className="m-auto">
                                            <Button className="rcs_fill_button" type="submit" disabled={buttonLoading}>
                                                Sign In {buttonLoading ? <CircularProgress className="rcs_loader" /> : ""}
                                            </Button>
                                        </Col>
                                    </Row>
                                    {errmsg ?
                                        <Row>
                                            <Col>
                                                <div className="rcs_signup_link rcs_signup_link_error">
                                                    <p>{msg}</p>
                                                </div>
                                            </Col>
                                        </Row> : ""}
                                    <Row>
                                        <Col>
                                            <div className="rcs_signup_link">
                                                <p>Don't have an account ? <NavLink to="/register" >Sign Up</NavLink></p>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                                <Row>
                                    <Col lg={10} className="m-auto">
                                        <div className="rcs_google_signup_main">
                                            <GoogleLogin
                                                clientId="549981789532-4bt0u9a45fujhv35ha0dil32bomr9221.apps.googleusercontent.com"
                                                buttonText="Sign in with Google"
                                                onSuccess={responseGoogle}
                                                onFailure={responseGoogle}
                                                cookiePolicy={'single_host_origin'}
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                {/* <FacebookLogin
                    appId="1088597931155576"
                    autoLoad={false}
                    fields="name,email,picture"
                    callback={responseFacebook}
                    cssclassName="my-facebook-button-class"
                    icon="fa-facebook"
                    /> */}
                            </div>
                        </Modal.Body>
                    </Col>
                </Row>
            </Container>
        </section>

    </>
    );
};

export default Login;